var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-spinner",class:_vm.classNames},[_c('div',{staticClass:"loading-spinner__inner"},[_c('div',{style:(_vm.style)}),_c('div',{style:(_vm.style)}),_c('div',{style:(_vm.style)}),_c('div',{style:(_vm.style)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }